import { jsx, Fragment } from 'react/jsx-runtime';
import React__default from 'react';
import { useSyncExternalStore } from 'use-sync-external-store';

var ReactOpener = function ReactOpener(_ref) {
  var store = _ref.store;
  var _useSyncExternalStore = useSyncExternalStore(store.subscribe, store.getState, store.getInitialState),
    items = _useSyncExternalStore.items,
    _close = _useSyncExternalStore.close;
  return jsx(Fragment, {
    children: items.map(function (item) {
      return jsx(React__default.Fragment, {
        children: typeof item.element === "function" ? item.element({
          id: item.id,
          close: function close() {
            return _close(item.id);
          }
        }) : item.element
      }, item.id);
    })
  });
};

export { ReactOpener };
